import styles from './style.css'
import googlePlayButton from 'assets/images/google-play-button.png'
import appStoreLogo from 'assets/images/app-store-logo.png'

export default class DownloadApp extends React.Component {
  componentDidMount () {
    var userAgentString = navigator.userAgent
    var linkAndroid = $('#googlePlayLink')
    var linkIos = $('#appstoreLink')
    if (userAgentString.indexOf('iPhone') > -1 || userAgentString.indexOf('iPod') > -1 || userAgentString.indexOf('iPad') > -1) {
      linkIos.attr('href', 'itms-apps://itunes.apple.com/app/id955811575')
      linkAndroid.attr('href', 'https://play.google.com/store/apps/details?id=com.mokapos.android')
      linkIos.attr('target', '')
    } else if (/Android/.test(userAgentString)) {
      linkIos.attr('href', 'https://itunes.apple.com/us/app/moka-pos/id955811575')
      linkAndroid.attr('href', 'market://details?id=com.mokapos.android')
      linkAndroid.attr('target', '')
    } else {
      linkIos.attr('href', 'https://itunes.apple.com/us/app/moka-pos/id955811575')
      linkAndroid.attr('href', 'https://play.google.com/store/apps/details?id=com.mokapos.android')
    }
  }
  shouldComponentUpdate (nextProps, nextState) {
    return false
  }

  render () {
    return (
      <div>
        <div className={styles.bold}>
          DOWNLOAD THE APP
        </div>
        <hr />
        <div className='col-md-8 no-padding'>
          <p>
            Download the Moka app for iPad from the App Store or for Android smartphones from the Google Play Store. Start selling today!
          </p>
        </div>
        <div className='col-md-4'>
          <a href='#' id='appstoreLink' target='_blank'>
            <img src={appStoreLogo} className={styles['logoButton']} />
          </a>
          <br />
          <br />
          <a href='#' id='googlePlayLink' target='_blank'>
            <img src={googlePlayButton} className={styles['logoButton']} />
          </a>
          <br />
          <br />
          <br />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/pages/RegisterComplete/DownloadApp.js